module.exports = {"522731001":"涟江街道","522731002":"濛江街道","522731102":"好花红镇","522731103":"摆金镇","522731104":"雅水镇","522731105":"断杉镇","522731106":"芦山镇","522731107":"王佑镇","522731108":"羡塘镇","522731109":"岗度镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522731.json
// module id = 2536
// module chunks = 0